import vueHighlight from "./components/vueHighlight.vue";

export default vueHighlight;
